import { baseDischargeSummary } from '../validations/discharge-summary/v1';
const shape = baseDischargeSummary.shape;
export const dischargeSummaryFields = [
    { key: 'condition', field: shape.condition, variant: 'list' },
    { key: 'goalsStatus', field: shape.goalsStatus },
    { key: 'servicesProvided', field: shape.servicesProvided, variant: 'list' },
    { key: 'careSummary', field: shape.careSummary },
    { key: 'conditionOfDischarge', field: shape.conditionOfDischarge },
    { key: 'dischargeDisposition', field: shape.dischargeDisposition, variant: 'list' },
    { key: 'dischargeInstructions', field: shape.dischargeInstructions },
    { key: 'verbalizedUnderstanding', field: shape.verbalizedUnderstanding },
    { key: 'otherNotes', field: shape.otherNotes, variant: 'list' },
];
